export default __webpack_public_path__ + "static/media/IBMCaretDown.21bd7d93.svg";